import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { Payment } from '../loan/Payments';
import { BaseLoanEvent } from './BaseLoanEvent';
import { NachaPaymentInfo } from './NachaPaymentInfo';

export const CreateMultipleAdvancesPaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createMultipleAdvancesPayment'),
  payment: Payment,
  advanceIds: z.array(FeeId).min(1),
  disableEmail: z.boolean().optional(),
  nachaPayment: NachaPaymentInfo.optional(),
});
export type CreateMultipleAdvancesPaymentEvent = z.infer<typeof CreateMultipleAdvancesPaymentEvent>;
